<template>
  <d2-container>
    <span>私有化部署</span>
  </d2-container>
</template>

<script>
export default {
  name: 'resources',
  data() {
    return {

    }
  },
}
</script>

<style scoped>
</style>
